import { normalizeModuleDefault } from '@eventbrite/legacy-infra.transformation-utils';
import { day as DAY_COLORS_JSON } from '@eventbrite/legacy-eds.theming';
import PropTypes from 'prop-types';
// Colors
import * as _COLORS_JSON from './color_colors.json';
import * as _GREYS_JSON from './color_greys.json';
import * as _REBRANDING_JSON from './color_rebranding_colors.json';

const COLORS_JSON = normalizeModuleDefault(_COLORS_JSON);
const GREYS_JSON = normalizeModuleDefault(_GREYS_JSON);
const REBRANDING_JSON = normalizeModuleDefault(_REBRANDING_JSON);

export const COLORS_MAP = {
    // Legacy color names
    ...COLORS_JSON,
    ...GREYS_JSON,
    // Theme color names
    ...DAY_COLORS_JSON,
    // Rebranding color names
    ...REBRANDING_JSON,
};
export const COLORS = Object.keys(COLORS_MAP);

export const COLORS_PROP_TYPE = PropTypes.oneOf(COLORS);
export { COLORS_JSON, GREYS_JSON, DAY_COLORS_JSON, REBRANDING_JSON };
